<template>
  <div class="loader">
  </div>
</template>

<script>
export default {
  name: 'Loader',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.loader {
  background: url('../assets/icons/loader.svg') no-repeat center center;
  width: 64px;
  height: 64px;
  display: block;
}
</style>
